import * as types from "./technician.action.types";

export default {
  [types.GET_TechnicianUsers]: (state, res) => {
    state.GET_TechnicianUsers = res;
  },
};
